export default __webpack_public_path__ + "static/media/signupImage.1836d0f7.png";